/**
 * Copyright(c) Live2D Inc. All rights reserved.
 *
 * Use of this source code is governed by the Live2D Open Software license
 * that can be found at https://www.live2d.com/eula/live2d-open-software-license-agreement_en.html.
 */
/**
 * Cubism SDKのサンプルで使用するWebGLを管理するクラス
 */
export class LAppGlManager {
    constructor() {
        Object.defineProperty(this, "_gl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this._gl = null;
    }
    initialize(canvas) {
        this._gl =
            canvas.getContext('webgl2') ??
                canvas.getContext('webgl') ??
                canvas.getContext('experimental-webgl');
        if (!this._gl) {
            console.error('Cannot initialize WebGL context.');
            return false;
        }
        return true;
    }
    /**
     * 解放する。
     */
    release() { }
    getGl() {
        return this._gl;
    }
}
